"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _image = _interopRequireDefault(require("../image"));
var mapFullImage = function mapFullImage(imageSlice) {
  if (!imageSlice || imageSlice.length === 0) return;
  var fullImagesArray = imageSlice.map(function (image) {
    var _image$primary$blurha, _image$primary$url, _image$primary$url$ur;
    return {
      title: image.primary.bigtitle.length > 0 ? image.primary.bigtitle[0].text : "",
      subHeading: image.primary.subtitle && image.primary.subtitle.length > 0 ? image.primary.subtitle[0].text : "",
      buttonLabel: image.primary.buttontext.length > 0 ? image.primary.buttontext[0].text : "",
      image: (0, _image["default"])(image.primary.image, ((_image$primary$blurha = image.primary.blurhash) === null || _image$primary$blurha === void 0 ? void 0 : _image$primary$blurha.length) > 0 && image.primary.blurhash.text),
      colorSchema: {
        fontColor: image.primary.textcolor,
        bgColor: image.primary.background
      },
      link: (_image$primary$url = image.primary.url) === null || _image$primary$url === void 0 ? void 0 : (_image$primary$url$ur = _image$primary$url.url) === null || _image$primary$url$ur === void 0 ? void 0 : _image$primary$url$ur.replace("https:/", "")
    };
  });
  return fullImagesArray;
};
var _default = mapFullImage;
exports["default"] = _default;